import App from '../App'
import { remoteOp } from '../helper'
import * as api from '../api'
import globalState from '../globalState'
import { Component, Prop, Vue } from 'vue-property-decorator';
import Cookies from 'js-cookie'

@Component({
  name: 'Menus'
})
export default class Menus extends Vue {
  get portals() {
    return (this.$root.$children[0] as App).portals
  }

  get uniForms() {
    return (this.$root.$children[0] as App).uniForms
  }

  close() {
    (this.$root.$children[0] as App).showMenu = false
    $(':focus', this.$el).blur()
  }

  clearCache() {
    this.close()
    remoteOp(null, '清除', '缓存', async () => {
      await api.invoke('runtime/clearCache');
    })
  }

  logout() {
    this.close();
    (this.$root.$children[0] as App).initialized = false
    globalState.auth = undefined
    Cookies.remove('x_sys_auth')
    this.$router.replace('/login')
  }
}
